import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  overlayClassName = '',
}) => {
  if (!isOpen) return null;

  const overlayClasses = ['confirmation-overlay', overlayClassName].filter(Boolean).join(' ');

  return (
    <div className={overlayClasses}>
      <div className="confirmation-modal">
        <div className="confirmation-header">
          <div className="confirmation-icon">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          <h3>{title}</h3>
        </div>
        
        <div className="confirmation-content">
          <p>{message}</p>
        </div>
        
        <div className="confirmation-actions">
          <button
            type="button"
            className="confirm-btn confirmation-cancel-btn"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
            <span>Cancel</span>
          </button>
          <button
            type="button"
            className="confirm-btn confirmation-remove-btn"
            onClick={onConfirm}
          >
            <i className="fas fa-trash-alt" aria-hidden />
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 